var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 118,
    viewBox: "0 0 101 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 92.5917V30.9974C3 8.59948 8.58824 3 30.9412 3H70.0588C92.4118 3 98 8.59948 98 30.9974V86.9922C98 87.7761 98 88.56 97.9441 89.344",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9265 75.8047H98V95.4029C98 106.21 89.2265 115.001 78.4412 115.001H22.5588C11.7735 115.001 3 106.21 3 95.4029V91.7632C3 82.972 10.1529 75.8047 18.9265 75.8047Z",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1494 31H72.8553",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1494 50.5898H56.0906",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReports);
export default __webpack_public_path__ + "static/media/emptyReports.2f560ff10c00f48241fd513bf9b4e3a6.svg";
export { ForwardRef as ReactComponent };